import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  cameraMainConatiner: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.5rem'
  },
  cameraFrameContainer: {
    width: '28.125rem',
    height: '20.375rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto'
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  cameraFaceBorder: {
    width: '55%',
    height: '80%',
    position: 'absolute',
    border: '5px dotted #fff',
    borderRadius: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '70%',
      height: '60%',
    },
  },
  secondaryBtnWrapper: {
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  primaryBtnWrapper: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  cameraOpenWrapper: {
    width: '100%',
    height: '100%'
  },
  cameraTakeViewMainWrapper: {
    display: 'inline-block',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
  },
  cameraTakeViewInsideWrapper: {
    transform: 'scale(1) rotate(0deg)',
    height: '100%'
  },
  cameraTakeView: {
    display: 'block',
    width: '100%',
    objectFit: 'cover',
    height: '100%',
  }
}));
